import { FilesUploader } from "components";
import { MediaDirectoryKeys, MediaType } from "constants/enums";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormField, MediaFilePicker } from "ui";

import { VideoFormAtomProps } from "../VideoForm.types";

import styles from "../VideoForm.module.scss";

const VideoField = ({ control }: VideoFormAtomProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.form__imagesContainer}>
      <Controller
        control={control}
        name="video"
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <FormField label={t("Upload Video")} errorMessage={error?.message}>
            <FilesUploader
              onSuccessUploading={onChange}
              uploadDirectoryKey={MediaDirectoryKeys.InventoryManager}
            >
              {(uploaderProps) => (
                <MediaFilePicker
                  {...uploaderProps}
                  allowedMediaTypes={[MediaType.VIDEO]}
                  value={value}
                  onDeleteMediaFile={() => onChange(null)}
                />
              )}
            </FilesUploader>
          </FormField>
        )}
      />
    </div>
  );
};

export default VideoField;
